const teamMembers = [
  {
    id: 1,
    name: 'Leopold Irungu',
    role: 'President',
    image: '/leopold.png',
    bio: 'Meet Leopold Irungu the Founder of this Shoe Store he does a lot for this shoe store he is a Member of Tri-County Quail Club and Also Founder of Heart Elementary School but Leo\'s role does not end there he helps his Pap and his uncle work outside in Kentucky and helps his Pap And Nannie. Outside of work he spends time with his Mother and Father he Also cooks with his Uncle and cooks by himself.'
  },
  {
    id: 2,
    name: 'Jessica Irungu',
    role: 'Assistant President',
    image: '/jessica.png',
    bio: 'I am Jessica I love it a lot here I am the Assistant President here. I ensure operational excellence and customer satisfaction every day. While I\'m out of work I spend time with my brother son and family.'
  },
  {
    id: 3,
    name: 'Logan Irungu',
    role: 'Security',
    image: '/logan.png',
    bio: 'I am Logan I like it here and I like keeping our store and customers safe with professional security services.'
  }
];

const Team = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-purple-50 to-pink-50" data-testid="team-page">
      <section className="py-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-sm uppercase tracking-wider text-[#EA580C] mb-3 font-bold" data-testid="team-label">
              Meet The Team
            </p>
            <h1 className="text-5xl md:text-6xl font-heading font-black text-[#0F172A] mb-4" data-testid="team-heading">
              Our Dedicated Team
            </h1>
            <p className="text-lg text-[#64748B] max-w-2xl mx-auto font-medium" data-testid="team-description">
              With 70 staff members, we're committed to providing exceptional service and helping you find the perfect fit.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto" data-testid="team-grid">
            {teamMembers.map(member => (
              <div
                key={member.id}
                className="bg-white border-4 border-[#0F172A] overflow-hidden rounded-2xl pop-shadow-sm group hover-lift"
                data-testid={`team-member-${member.id}`}
              >
                <div className="aspect-square overflow-hidden bg-gradient-to-br from-orange-100 to-purple-100">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    data-testid="team-member-image"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-heading font-bold text-[#0F172A] mb-1" data-testid="team-member-name">
                    {member.name}
                  </h3>
                  <p className="text-sm text-[#EA580C] font-bold mb-3 uppercase tracking-wide" data-testid="team-member-role">
                    {member.role}
                  </p>
                  <p className="text-sm text-[#64748B] leading-relaxed" data-testid="team-member-bio">
                    {member.bio}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-gradient-to-r from-[#14B8A6] to-[#0D9488]" data-testid="values-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center bg-white/20 backdrop-blur-md p-8 rounded-2xl border-4 border-white hover-lift" data-testid="value-card-1">
              <div className="w-20 h-20 bg-white text-[#14B8A6] flex items-center justify-center mx-auto mb-4 text-3xl font-heading font-black rounded-2xl shadow-lg">
                70+
              </div>
              <h3 className="text-xl font-heading font-black text-white mb-2">Team Members</h3>
              <p className="text-white font-medium">Ready to help you find your perfect fit</p>
            </div>
            <div className="text-center bg-white/20 backdrop-blur-md p-8 rounded-2xl border-4 border-white hover-lift" data-testid="value-card-2">
              <div className="w-20 h-20 bg-white text-[#14B8A6] flex items-center justify-center mx-auto mb-4 text-3xl font-heading font-black rounded-2xl shadow-lg">
                25+
              </div>
              <h3 className="text-xl font-heading font-black text-white mb-2">Years Experience</h3>
              <p className="text-white font-medium">Serving families with quality footwear</p>
            </div>
            <div className="text-center bg-white/20 backdrop-blur-md p-8 rounded-2xl border-4 border-white hover-lift" data-testid="value-card-3">
              <div className="w-20 h-20 bg-white text-[#14B8A6] flex items-center justify-center mx-auto mb-4 text-3xl font-heading font-black rounded-2xl shadow-lg">
                100%
              </div>
              <h3 className="text-xl font-heading font-black text-white mb-2">Customer Focused</h3>
              <p className="text-white font-medium">Your satisfaction is our priority</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;